import axios from 'axios'
import {
  ExportDataModel,
  ExportDataApplicationModel,
  ExportDataFormModel,
  ExportDataTableByApplicationModel,
  ResponseObject,
  ResponseObjectPaginated,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getModules(dto: ExportDataApplicationModel, page: number) {
  return axios.post<ResponseObject<ExportDataApplicationModel[]>>(
    `${BASEURL}/exportTables/getAllApplication/${page}`,
    dto,
  )
}

export function getTablesByModule(dto: ExportDataTableByApplicationModel, page: number) {
  return axios.post<ResponseObjectPaginated<ExportDataTableByApplicationModel[]>>(
    `${BASEURL}/exportTables/getTablesForApplication`,
    dto,
  )
}

export function getTableData(dto: ExportDataModel) {
  return axios.post<ResponseObjectPaginated<ExportDataModel[]>>(
    `${BASEURL}/exportTables/getTableStructure`,
    dto,
  )
}

// INICIO ---- SERVICIOS EXPORT
export function getExportRDataReportPDF(dto: ExportDataFormModel) {
  return axios.post<any>(`${BASEURL}/exportTables/getDataWithTableFiltersPDF`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getExportRDataReportXLS(dto: ExportDataFormModel) {
  return axios.post<any>(`${BASEURL}/exportTables/getDataWithTableFiltersExcel`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getExportRDataReportCSV(dto: ExportDataFormModel) {
  return axios.post<any>(`${BASEURL}/exportTables/getDataWithTableFiltersCSV`, dto, {
    responseType: 'arraybuffer',
  })
}

// FIN ---- SERVICIOS EXPORT
